import { render } from "./InsuranceBadge.vue?vue&type=template&id=81534f0a&scoped=true&lang=pug"
import script from "./InsuranceBadge.vue?vue&type=script&lang=js"
export * from "./InsuranceBadge.vue?vue&type=script&lang=js"

import "./InsuranceBadge.vue?vue&type=style&index=0&id=81534f0a&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81534f0a"]])

export default __exports__